// Spin 主狀態 — 對應 Unity Slot001_SlotStateEnum（精簡為有意義的流程節點）。
export enum SpinState {
  Init = 'INIT',
  Idle = 'IDLE',
  StartSpin = 'START_SPIN',
  Rotate = 'ROTATE',
  RotateEnd = 'ROTATE_END',
  WinCheck = 'WIN_CHECK',
  WinShow = 'WIN_SHOW',
  Bonus = 'BONUS',
  BigWin = 'BIG_WIN',
  SpinEnd = 'SPIN_END',
}
